export interface MessageViewModel {
  id?: number;
  createdBy?: string;
  createdAt?: string;
  from?: string;
  message?: string;
  status?: string;
  to?: string;
  readAt?: string;
  isRead?: boolean;
  direction?: string;
  duration?: number;
  conversationTypeId?: number;
  customerName?: string;
  numbers?: string[];
  attachments?: MessageMediaViewModel[];
  callTypeId?: number;
  callTypeName?: string;
  storeNumber?: string;
}

export interface AppointmentMessageViewModel {
  id?: number;
  createdBy?: string;
  createdAt?: Date;
  from?: string;
  body?: string;
  status?: string;
  storeId?: number;
  to?: string;
  readAt?: Date;
  isRead?: boolean;
  vin?: string;
  direction?: string;
  duration?: number;
  customerKey?: string;
  conversationTypeId?: number;
  customerName?: string;
  appointmentNumber?: string;
  appointmentDateTime?: string;
  numbers?: string[];
  attachments?: MessageMediaViewModel[];
  callTypeId?: number;
  callTypeName?: string;
}
export interface MessageMediaViewModel {
  mediaUrl?: string;
  attachmentTypeId?: number;
}

export interface MessageAttachment {
  fileBase64: string;
  fileExtension: string;
}

export interface Base64Attachment {
  fileBase64: string;
  base64: string;
  extension: string;
  fileSize: number;
  fileName: string;
  responseStatus: any;
  fileExtension: string;
}

export interface NewConversationViewModel {
  storeId?: number;
  repairOrderNumber?: string;
  to?: string;
  customerName?: string;
  body?: string;
  existingMessages?: MessageViewModel[];
  messages?: MessagesViewModel[];
  template?: string;
  customerKey?: string;
  conversationId?: string;
  sendTo?: string;
  from?: string;
  files?: FileViewModel[];
  redirectedFrom?: string;
}

export interface NewAppointmentViewModel {
  storeId?: number;
  repairOrderNumber?: string;
  to?: string;
  customerName?: string;
  body?: string;
  status?: string;
  existingMessages?: MessageViewModel[];
  template?: string;
  customerKey?: string;
  conversationId?: string;
  sendTo?: string;
  from?: string;
  vin?: string;
  files?: FileViewModel[];
  redirectedFrom?: string;
  appointmentNumber?: string;
  appointmentDateTime?: string;
}
export interface FileViewModel {
  base64: string;
  extension: string;
  fileSize: number;
  fileName: string;
  arrayBuffer?: any;
}

export interface StoreConversationViewModel {
  roConversations?: ConversationViewModel[];
  customerConversations?: ConversationViewModel[];
  orphanConversations?: ConversationViewModel[];
  storeLogo?: string;
  storeDealershipName?: string;
  storeId?: number;
}
export interface ConversationViewModel {
  customerName?: string;
  from?: string;
  id?: number;
  isRead?: boolean;
  repairOrderNumber?: string;
  storeId?: number;
  to?: string;
  unreadMessageCount?: number;
  customerKey?: string;
}

export interface MessagesViewModel {
  id?: string;
  storeId?: number;
  messageJson?: MessageJson;
  metadataJson?: MetadataJson;
  totalRecords?: number;
  storeName?: string;
  storeNumber?: string;
  createdAt?: string;
  guid?: string;
  sending?: boolean;
  sent?: boolean;
  error?: string;
  files?: FileViewModel[];
  attachments?: MessageAttachmentViewModel[];
  existingMessages?: MessagesViewModel[];
  vin?: string;
  appointmentDateTime?: string;
  appointmentNumber?: string;
  enterpriseId?: number;
  createdBy?: string;
  firstName?: string;
  lastName?: string;
}

export interface MessageAttachmentViewModel {
  uri: string;
  attachmentId?: string;
}

export interface MessageTextJson {
  body?: string;
}
export interface MessageVoiceJson {
  direction?: string;
  duration?: string;
  answeredBy?: string;
  startTime?: string;
  endTime?: string;
  callType?: string;
}
export interface MetadataJson {
  recordKey?: string;
  recordIdentifier?: string;
  recordKeyIdentifier?: string;
}

export class NewMessage {
  public customerKey: string;
  public customerName: string;
  public vin: string;
  public type: string;
  public from: string;
  public to: string;
  public body: string;
  public metadataJson: MetadataJson;
}

export class MessageCreateViewModel {
  public type: string;
  public to: string;
  public customerKey: string;
  public customerName: string;
  public vin: string;
  public body: string;
  public template: string;
  public files: FileViewModel[];
  public recordKey: string;
  public recordIdentifier: string;
  public recordKeyIdentifier: string;
  public appointmentNumber: string;
  public appointmentDateTime: string;
  constructor(type: string) {
    this.type = type;

    this.to = '';
    this.customerName = '';
    this.body = '';
    this.template = '';

    this.recordKey = '';
  }
}

export class AdhocFaxViewModel {
  public from: string;
  public type: string;
  public to: string;
  public customerName: string;
  public file: FileViewModel;
  constructor(type: string) {
    this.type = type;
    this.to = '';
    this.from = '';
  }
}

export class NewFaxViewModel {
  public from: string;
  public type: string;
  public to: string;
  public recordKey: string;
  public recordIdentifier: string;
  public recordKeyIdentifier: string;
  constructor(type: string) {
    this.type = type;
    this.to = '';
    this.from = '';
    this.recordKey = '';
  }
}

export interface MessageJson {
  type?: string;
  from?: string;
  textJson?: MessageTextJson;
  sid?: string;
  Status?: string;
  isRead?: boolean;
  readAt?: string;
  responseJson?: string;
  to?: string;
  callTypeId?: string;
  parentSid?: string;
  entTime?: string;
  startTime?: string;
  answeredBy?: string;
  direction?: string;
  duration?: string;
  attachments?: string[];
  recordKey?: string;
  voiceJson?: MessageVoiceJson;
  customerKey?: string;
  customerName?: string;
  /// properties mapped for UI problems.
  roNumber?: string;
  appointmentNumber?: string;
  body?: string;
}

export interface MessageDetailViewModel {
  id?: number;
  totalRecords?: number;
  attendingUserName?: string;
  recordIdentifier?: string;
  from?: string;
  to?: string;
  sender?: string;
  receiver?: string;
  status?: string;
  direction?: string;
  messageBody?: string;
  isReadJson?: boolean;
  conversationType?: string;
  createdAt?: Date | null;
  customerKey?: string;
}

export interface ConversationListViewModel {
  messages?: MessageListViewModel[];
  unreadCount?: number;
  unAttendedCount?: number;
  attendedCount?: number;
}

export interface MessageListViewModel {
  createdAt: string;
  createdBy: string;
  customerKey: string;
  from: string;
  message: string;
  status: string;
  to: string;
  conversationId: number;
  repairOrderNumber: string;
  customerName: string;
  storeId: string;
}

export interface Device {
  value?: string;
  text?: string;
}

export class EmailCreateViewModel {
  public type: string;
  public toEmail: string;
  public from: string;
  public subject: string;
  public customerKey: string;
  public customerName: string;
  public vin: string;
  public body: string;
  public template: string;
  public files: FileViewModel[];
  public recordKey: string;
  public recordIdentifier: string;
  public recordKeyIdentifier: string;
  public appointmentNumber: string;
  public appointmentDateTime: string;
  public candidateName: string;
  public ccEmails: string[];
  constructor(type: string) {
    this.type = type;
    this.toEmail = '';
    this.body = '';
    this.template = '';
    this.recordKey = '';
    this.candidateName = '';
    this.subject = '';
    this.ccEmails = [];

  }
}


